import { CheckCircle } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const EmployerOEStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Not Ready', value: 'not_ready' },
    { label: 'Ready For Open Enrollment', value: 'ready_for_open_enrollment' },
    { label: 'Employees Confirmed', value: 'employees_confirmed' },
    { label: 'Accepted Preliminary Quote', value: 'accepted_preliminary_quote' },
    { label: 'Accepted Final Quote', value: 'accepted_final_quote' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Status', options: filteredOptions || [] }]}
        placeholder='Search statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='Status'
          pluralIdentifier='statuses'
        >
          <CheckCircle size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EmployerOEStatusFilter
